import { createSlice } from "@reduxjs/toolkit";
import * as action from "../actions/chatActions";

export const chatSlicer = createSlice({
  name: "chat",
  initialState: {
    chats: null,
    loading: false,
    error: null,
    unread: {
      total: 0,
      chats: [],
    },
    messages: [],
    activeChat: "",
  },
  reducers: {
    increaseUnread: (state, { payload }) => {
      const { chatId } = payload;

      const chat = state.unread.chats.find((c) => c.chatId === chatId);

      if (chat) {
        chat.count += 1;
      } else {
        state.unread.chats.push({ chatId, count: 1 });
      }

      state.unread.total += 1;
    },
    setActiveChat: (state, { payload }) => {
      state.activeChat = payload;
    },
    setMessages: (state, { payload }) => {
      state.messages = payload;
    },
    addMessage: (state, { payload }) => {
      state.messages.unshift(payload);
    },
    addChat: (state, { payload }) => {
      if (state.chats) {
        const existingChat = state.chats.find((c) => c._id === payload._id);
        if (!existingChat) {
          state.chats.unshift(payload);
        }
      } else {
        state.chats = [payload];
      }
    },
    removeMessage: (state, { payload }) => {
      state.messages = state.messages.filter((msg) => msg._id !== payload);
    },
  },
  extraReducers: {
    [action.getAllChats.pending]: (state) => {
      state.loading = true;
    },
    [action.getAllChats.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.chats = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.getUnreadCounts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.unread = data;
      }
    },
    [action.markAsRead.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200 && data.chatId) {
        const chat = state.unread.chats.find((c) => c.chatId === data.chatId);
        if (chat) {
          state.unread.total -= chat.count;
          chat.count = 0;
        }
      }
    },
  },
});

export default chatSlicer.reducer;
